import { createReducer, createNamespacer } from './../commons/js/utils/reducer';
import { combineReducers } from "redux";

const initialState = {
    list: {
        isLoading: false,
        spools: [],
        error: "",
        currentPage: 1,
        pageCount: 1,
        pdfView: false,
        highlightSpoolState: '',
    }
}

const listSpools = createNamespacer("SEARCH_SPOOLS_LIST")

export const listReducer = createReducer(initialState.list, {
    [listSpools("SET_SPOOLS")]: (state, action) => {
        return {
            ...state,
            spools: action.payload.value.spools,
            pageCount: action.payload.pages
        }
    },
    [listSpools("SET_PDF_VIEW")]: (state, action) => {
        return {
            ...state,
            pdfView: action.payload.value,
        }
    },
    [listSpools("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialState.list
        }
    },
    [listSpools("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [listSpools("HIGHLIGHT_SPOOL")]: (state, action) => {
        return {
            ...state,
            highlightSpoolState: action.payload.highlightSpool,
        }
    },
});
const reducer = combineReducers({
    list: listReducer,
})

export default reducer;